import React from "react";
import { Link } from "react-router-dom";
import "./TermsOfService.css";
import StaticPageHeaders from "../../Components/StaticPageHeaders";
import NavbarCustom from "../../Components/NavbarCustom";
import SEO from "../../Components/SEO";

const TermsOfService = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <SEO
        title="Terms of Service - Shootin School Inc"
        description="Terms of Service and SMS Messaging Compliance"
        url="https://shootinschool.com/terms-of-service"
      />

      <NavbarCustom />
      <StaticPageHeaders title="Terms of Service" />

      <div className="privacy-container brightness">
        <div className="privacy-inside">
          <p className="text-clip">
            <strong>Shootin School Inc</strong>
            <br />
            <strong>Effective Date: Jan 1st, {currentYear}</strong>
          </p>

          <h2 className="text-clip">SMS Messaging Terms & Compliance</h2>

          <h3 className="text-clip">1. Program Description</h3>
          <p className="text-clip">
            This messaging program sends appointment confirmations and reminder
            messages to customers who have booked an appointment with Shootin
            School Inc through our website at{" "}
            <Link to="/">
              <span className="text-clip">https://shootinschool.com</span>
            </Link>{" "}
            or via our scheduling forms and have explicitly opted in to receive
            SMS notifications. Messages include appointment confirmations,
            reminders, rescheduling updates, and customer support
            communications.
          </p>

          <h3 className="text-clip">2. Cancellation Instructions</h3>
          <p className="text-clip">
            You can cancel the SMS service at any time. Simply text "STOP" to
            the shortcode. Upon sending "STOP," we will confirm your unsubscribe
            status via SMS. Following this confirmation, you will no longer
            receive SMS messages from us. To rejoin, sign up as you did
            initially, and we will resume sending SMS messages to you.
          </p>

          <h3 className="text-clip">3. Support Information</h3>
          <p className="text-clip">
            If you experience issues with the messaging program, reply with the
            keyword HELP for more assistance, or reach out directly to{" "}
            <a className="text-clip" href="mailto:shootinschool@gmail.com">
              shootinschool@gmail.com
            </a>
            . For assistance, reply <strong>HELP</strong> or contact us at
            <a className="text-clip" href="tel:1-347-212-0028">
              {" "}
              1-347-212-0028
            </a>
          </p>

          <h3 className="text-clip">4. Carrier Liability</h3>
          <p className="text-clip">
            Carriers are not liable for delayed or undelivered messages.
          </p>

          <h3 className="text-clip">5. Message & Data Rates</h3>
          <p className="text-clip">
            As always, message and data rates may apply for messages sent to you
            from us and to us from you. Message frequency varies. For questions
            about your text plan or data plan, contact your wireless provider.
          </p>

          <h3 className="text-clip">6. Supported Carriers</h3>
          <p className="text-clip">
            Our SMS program supports major U.S. carriers including AT&amp;T,
            Verizon, T-Mobile, Sprint, and most regional carriers.
          </p>

          <h3 className="text-clip">7. Age Restriction</h3>
          <p className="text-clip">
            You must be 18 years of age or older to participate.
          </p>

          <h3 className="text-clip">8. Privacy Policy</h3>
          <p className="text-clip">
            For privacy-related inquiries, please refer to our privacy policy:
            <Link to="/privacy-policy">
              <span className="text-clip">https://shootinschool.com/privacy-policy</span>
            </Link>
            .
          </p>

          <p className="text-clip">
            We comply with the Telephone Consumer Protection Act (TCPA) and CTIA
            guidelines governing SMS communications.
          </p>

          <h2 className="text-clip">General Terms</h2>
          <p className="text-clip">
            This website (the "Site") is owned and operated by Shootin School
            Inc. By accessing or using the Site, you agree to be bound by these
            Terms of Service, our Privacy Policy, and any additional terms
            applicable to specific services.
          </p>

          <h2 className="text-clip">Intellectual Property Rights</h2>
          <p className="text-clip">
            All content on this Site is owned by Shootin School Inc or its
            licensors and is protected by copyright, trademark, and intellectual
            property laws. Content is provided for personal, non-commercial use
            only.
          </p>

          <p className="text-clip">
            You may not reproduce, distribute, modify, or exploit Site content
            without written permission. You may print a single copy for
            personal, non-commercial use with all copyright notices intact.
          </p>

          <h3 className="text-clip">Your License to Us</h3>
          <p className="text-clip">
            By submitting content to us, you grant Shootin School Inc a
            perpetual, royalty-free, worldwide license to use, modify,
            distribute, and display such content.
          </p>

          <h2 className="text-clip">Disclaimers</h2>
          <p className="text-clip">
            The Site and its content are provided "as is" without warranties of
            any kind. We disclaim all implied warranties to the fullest extent
            permitted by law.
          </p>

          <p className="text-clip">
            You agree to indemnify and hold harmless Shootin School Inc from any
            claims arising from your use of the Site or violation of these
            Terms.
          </p>

          <h2 className="text-clip">Online Commerce</h2>
          <p className="text-clip">
            We are not responsible for third-party products or services
            purchased through links on our Site. Any transactions are solely
            between you and the third party.
          </p>

          <h2 className="text-clip">Registration & Passwords</h2>
          <p className="text-clip">
            You are responsible for maintaining the confidentiality of your
            account credentials. Notify us immediately of unauthorized access at{" "}
            <a className="text-clip" href="mailto:shootinschool@gmail.com">
              shootinschool@gmail.com
            </a>
            .
          </p>

          <h2 className="text-clip">Termination</h2>
          <p className="text-clip">
            We reserve the right to suspend or terminate access to the Site for
            violations of these Terms without notice.
          </p>

          <h2 className="text-clip">Governing Law</h2>
          <p className="text-clip">
            These Terms are governed by the laws of the state in which Shootin
            School Inc operates. Any disputes shall be resolved through binding
            arbitration in that jurisdiction.
          </p>

          <h2 className="text-clip">Changes to Terms of Service</h2>
          <p className="text-clip">
            We may update these Terms from time to time. The latest version will
            always be posted on this page with the effective date.
          </p>

          <h2 className="text-clip">Contact Us</h2>
          <p className="text-clip">
            <strong>Shootin School Inc</strong>
            <br />
            Phone: 1-347-212-0028
            <br />
            Email:{" "}
            <a href="mailto:shootinschool@gmail.com">
              <span className="text-clip">shootinschool@gmail.com</span>
            </a>
            <br />
            Website:{" "}
            <Link to="/">
              <span className="text-clip">https://shootinschool.com</span>
            </Link>
          </p>

          <p className="text-clip">
            By using our website and services, you consent to these Terms of
            Service.
          </p>
        </div>
      </div>
    </>
  );
};

export default TermsOfService;
